import React, { useState } from "react";
import { toast } from "sonner";
import { SetupGuide } from "./components/setup-guide";
import { OverviewStats } from "./components/overview-stats";
import { LiveCallsTable } from "./components/live-calls-table";
import { TranscriptDrawer } from "./components/transcript-drawer";
import { StartCallModal } from "./components/start-call-modal";
import { INITIAL_LIVE_CALLS } from "./data";
import { LiveCallRow } from "./types";

// Call Management — /calls. UI only for now (no calls backend exists yet):
// setup guide, overview stats and the live-calls log are static/mock data,
// same convention already used for the CDP Unify page. The "Start a Call"
// wizard is fully interactive client-side state though, so it can be wired
// to a real endpoint later without changing this page's shape.
const Calls: React.FC = () => {
  const [calls, setCalls] = useState<LiveCallRow[]>(INITIAL_LIVE_CALLS);
  const [transcriptCall, setTranscriptCall] = useState<LiveCallRow | null>(null);
  const [isStartCallOpen, setIsStartCallOpen] = useState(false);

  const handleCallCompleted = (row: LiveCallRow) => {
    setCalls((prev) => [row, ...prev]);
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 p-4 sm:p-6">
      <div className="space-y-6">
        <SetupGuide onSetupCalls={() => toast("Full call setup flow is coming soon — try Start a Call below to see the call flow.")} />
        <OverviewStats />
        <LiveCallsTable
          calls={calls}
          onViewTranscript={setTranscriptCall}
          onStartCall={() => setIsStartCallOpen(true)}
        />
      </div>

      <TranscriptDrawer call={transcriptCall} onClose={() => setTranscriptCall(null)} />
      <StartCallModal
        isOpen={isStartCallOpen}
        onClose={() => setIsStartCallOpen(false)}
        onCallCompleted={handleCallCompleted}
      />
    </div>
  );
};

export default Calls;
 